"use client";

import { c as _c } from "react/compiler-runtime";
import ToggleIcon from "@/assets/images/elements/icon_pfeile_rechts.svg";
import { cn } from "@/lib/utils";
import { type ReactNode, useState } from "react";
type Props = {
  title: string;
  children: ReactNode;
  toggleHeight: string;
  initiallyOpen?: boolean;
};
export default function DropdownToggle(t0) {
  const $ = _c(22);
  const {
    title,
    children,
    toggleHeight,
    initiallyOpen
  } = t0;
  const [isOpen, setIsOpen] = useState(initiallyOpen ?? true);
  const [isAnimating, setIsAnimating] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function toggleEvent() {
      setIsOpen(_temp);
      setIsAnimating(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const toggleEvent = t1;
  let t2;
  if ($[1] !== title) {
    t2 = <div className="grow text-sm font-bold italic lg:text-normal">{title}</div>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = isOpen ? "rotate-90" : "-rotate-90";
  let t4;
  if ($[3] !== t3) {
    t4 = cn("h-6 w-auto text-matchbus transition-transform duration-300", t3);
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <ToggleIcon className={t4} />;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t5) {
    t6 = <button className="mb-4 flex w-full flex-row items-center border-0 border-b-2 border-solid border-matchbus p-2 font-normal text-secondary" type="button" onClick={toggleEvent}>{t2}{t5}</button>;
    $[7] = t2;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setIsAnimating(false);
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = isOpen ? toggleHeight : 0;
  let t9;
  if ($[11] !== t8) {
    t9 = {
      height: t8
    };
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = isAnimating ? "overflow-hidden" : isOpen ? "overflow-visible" : "overflow-hidden";
  let t11;
  if ($[13] !== t10) {
    t11 = cn("transition-[height] delay-150 duration-500 ease-in-out", t10);
    $[13] = t10;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== children || $[16] !== t11 || $[17] !== t9) {
    t12 = <div onTransitionEnd={t7} style={t9} className={t11}>{children}</div>;
    $[15] = children;
    $[16] = t11;
    $[17] = t9;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t12 || $[20] !== t6) {
    t13 = <div>{t6}{t12}</div>;
    $[19] = t12;
    $[20] = t6;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  return t13;
}
function _temp(v) {
  return !v;
}